import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import ODataStore from 'devextreme/data/odata/store';
import { ApiErrorHandlerService } from '@bds/helpers';
import { EquipReportCatgValue } from '../../models';

@Injectable({
    providedIn: 'root',
})
export class EquipReportCatgValueService {
    controllerName = 'EquipReportCategoryValue';

    constructor(
        private http: HttpClient,
        @Inject('BASE_API_URL') private apibaseUrl: string,
        @Inject('BASE_ODATA_URL') private odatabaseUrl: string,
        private apiErrorHandler: ApiErrorHandlerService,
    ) {}

    create(equipcatgvalue: EquipReportCatgValue): Observable<EquipReportCatgValue> {
        return this.http
            .post<EquipReportCatgValue>(`${this.apibaseUrl}${this.controllerName}`, equipcatgvalue)
            .pipe(
                map((data: EquipReportCatgValue) => {
                    return data ? data : null;
                }),
                catchError((err) => this.apiErrorHandler.handleError(err)),
            );
    }

    getAll(expand?: string[]): Observable<EquipReportCatgValue[]> {
        let expandUrl = '';
        if (expand && expand.length > 0) {
            expandUrl = '?$expand=';
            expand.forEach((child) => (expandUrl = expandUrl + child + ','));
            expandUrl = expandUrl.slice(0, expandUrl.length - 1);
        }
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-explicit-any
        return this.http.get<any>(`${this.odatabaseUrl}${this.controllerName}` + expandUrl).pipe(
            map((data) =>
                // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
                data.value.map((i) => {
                    const adapt = i as EquipReportCatgValue;
                    adapt.equipReportCatgVal = adapt.equipReportCatgVal.toUpperCase();
                    return adapt;
                }),
            ),
            shareReplay(),
            catchError((err) => this.apiErrorHandler.handleError(err)),
        );
    }

    getODataStore(): ODataStore {
        const keyField = 'ormId';

        return new ODataStore({
            version: 4,
            url: `${this.odatabaseUrl}${this.controllerName}`,
            key: keyField,
        });
    }

    read(key: number, expand?: string[]): Observable<EquipReportCatgValue> {
        let expandUrl = '';
        if (expand && expand.length > 0) {
            expandUrl = '?$expand=';
            expand.forEach((child) => (expandUrl = expandUrl + child + ','));
            expandUrl = expandUrl.slice(0, expandUrl.length - 1);
        }
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-explicit-any
        return this.http
            .get<EquipReportCatgValue>(
                `${this.odatabaseUrl}${this.controllerName}(${key})` + expandUrl,
            )
            .pipe(
                // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-return
                map((data: any) => data),
                shareReplay(),
                catchError((err) => this.apiErrorHandler.handleError(err)),
            );
    }

    update(key: number, equipcatgvalue: EquipReportCatgValue): Observable<EquipReportCatgValue> {
        return this.http
            .put<EquipReportCatgValue>(
                `${this.apibaseUrl}${this.controllerName}/${key}`,
                equipcatgvalue,
            )
            .pipe(
                map((data: EquipReportCatgValue) => {
                    return data ? data : null;
                }),
                catchError((err) => this.apiErrorHandler.handleError(err)),
            );
    }
}
